import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../redux/actions'

import Information from '../views/information/information_center/information_center'

class CenterInformationsController extends Component {

	render() {

		const informationCloseHandler = id => {
			this.props.actions.closeMessage(id, 'centerInformation')
		}

		const informationLength = this.props.centerInformation.array.length
		const informationElement = this.props.centerInformation.array[0]||{}

		return (
			<Information
				visible={informationLength?true:false}
				timeout={informationElement.timeout}
				onInformationClose={informationCloseHandler}
				informationId={informationElement.uid}>
				{informationElement.message}
			</ Information>
		)

	}

}

CenterInformationsController.propTypes = {
	actions: PropTypes.object,
	centerInformation: PropTypes.object,
}

function mapStateToProps(state) {
	return { centerInformation: state.centerInformation }
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CenterInformationsController)
